import { useContext, useMemo } from 'react';
import { useUser } from '@clerk/clerk-react';
import { AppAuthContext } from '../contexts/AppAuthContext';

const getFirstName = (username = '') => {
	const trimmed = String(username).trim();
	if (!trimmed) return '';
	return trimmed.split(/\s+/)[0];
};

export const useAuthUser = () => {
	const clerkState = useUser();

	const {
		isTestAuthEnabled,
		testAuthSession,
		clearTestAuthSession
	} = useContext(AppAuthContext);

	const testUser = useMemo(() => {
		if (!testAuthSession?.user) return null;
		const sourceUser = testAuthSession.user;
		const username = sourceUser.username || sourceUser.email || 'Athlete';
		return {
			id: sourceUser.userID,
			username,
			firstName: getFirstName(username),
			fullName: username,
			emailAddresses: sourceUser.email ? [{ emailAddress: sourceUser.email }] : [],
			profileImageUrl: sourceUser.profileImageLink || ''
		};
	}, [testAuthSession]);

	const shouldUseTestAuth = isTestAuthEnabled && Boolean(testUser);

	if (shouldUseTestAuth) {
		return {
			user: testUser,
			isLoaded: true,
			isSignedIn: Boolean(testUser),
			signOut: clearTestAuthSession,
			isTestAuthEnabled: true
		};
	}

	return {
		...clerkState,
		signOut: null,
		isTestAuthEnabled: false
	};
};
